<template>
  <v-layout
    row
    align-center
    v-if="showCountdownTimer === true && complete == false"
   class="countdown"
  >
    <v-flex xs12 sm4>
      <v-icon class="pa-1">
        access_time
      </v-icon>
    </v-flex>
    <v-flex xs10>
      Session will expire in {{ countdown }}
    </v-flex>
  </v-layout>
</template>

<script>
import Shared from "@/mixins/Shared";
import { EventBus } from "@/services/EventBus.js";

export default {
  name: "CountdownTimer",
  mixins: [Shared],
  data() {
    return {
      countdown: ""
    };
  },
  computed: {
    countdown_timer() {
      return this.countdownTimer;
    }
  },
  watch: {
    fareType(fareType) {
      this.showFareType = [fareType.label];
    }
  },
  mounted() {
    EventBus.$on('updateCountdownTimer', (timer) => {
      this.countdown = timer.time;
    });
  }
};
</script>
